// extracted by mini-css-extract-plugin
export default {"contacts":"styles_contacts__83jwu","text":"styles_text__j33g8","email":"styles_email__D9WGv"};